import { Component, inject } from '@angular/core';
import { BrandingService } from '@insolution/branding-util';
import { CurrentTenantService } from '@insolution/tenant-data-access';

@Component({
  selector: 'lib-default-layout',
  imports: [],
  templateUrl: './default-layout.html',
  styleUrl: './default-layout.scss',
})
export class DefaultLayout {
  protected currentTenantName = inject(CurrentTenantService).currentTenantName;
  protected logoUrl = inject(BrandingService).logoUrl;
}
